<div class="page-container">
    <div [id]="'renderDocumentElement'+document.id" [innerHTML]="renderedDocument"></div>
</div>